var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuppliedShippedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85605 1.14718C6.62343 0.304015 5.40761 0.264757 5.14394 1.14718C3.77373 5.76905 0.84375 7.02501 0.84375 10.2825C0.84375 13.1665 3.15 15.5 6 15.5C8.84999 15.5 11.1562 13.1665 11.1562 10.2825C11.1562 7.0086 8.23271 5.79014 6.85605 1.14718V1.14718ZM6 13.625C4.19092 13.625 2.71875 12.1528 2.71875 10.3438C2.71875 10.0848 2.92851 9.875 3.1875 9.875C3.44648 9.875 3.65625 10.0848 3.65625 10.3438C3.65625 11.636 4.70771 12.6875 6 12.6875C6.25898 12.6875 6.46875 12.8973 6.46875 13.1563C6.46875 13.4152 6.25898 13.625 6 13.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliedShippedIcon);
export default __webpack_public_path__ + "static/media/supplied-shipped-icon.6fb2b59f8516d1b6de15e73cb808013b.svg";
export { ForwardRef as ReactComponent };